module.exports = __webpack_public_path__ + "static/media/filter_search_ja.b20b0e9d.gif";